import { render, staticRenderFns } from "./ActionChoice.vue?vue&type=template&id=011f7170"
import script from "./ActionChoice.vue?vue&type=script&lang=js"
export * from "./ActionChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports